export default "//yastatic.net/s3/distribution/pythia/frontend/_/71ec369099228c809398b8135543794d.png";